<!-- Wrapper -->
<div class="flex flex-col bg-[#f1f1f1] min-h-[80vh] p-4 sm:p-[50px]"  [ngClass]="brandname">
    <!-- Breadcrumb -->
  <div class="flex flex-col sm:flex-row mb-4">
    <div class="w-full sm:w-4/12 flex justify-start items-center">
      <p>
        <a routerLink="/">Home</a>
        <span class="mx-1">&gt;</span>
        <span class="font-bold" translate>Productdetails</span>
      </p>
    </div>
  </div>
  <!-- Main content -->
  <div class="flex flex-col md:flex-row w-full gap-6">

    <!-- Product Image with fixed aspect ratio -->
    <div class="w-full flex justify-center sm:justify-end">
      <div class="aspect-w-4 aspect-h-3 w-full max-w-[900px]">
        <img
          *ngIf="campaign"
          [src]="baseUrl + '/api/images/' + campaign.homepageImageId"
          alt="product"
          class="object-cover w-full h-auto rounded-md cursor-pointer shadow-md bg-[#fafafa]"
        />
      </div>
    </div>

    <!-- Product Info -->
    <div class="w-full sm:ml-10">
      <h1 *ngIf="campaign" class="text-2xl font-semibold text-center">
        {{ campaign.name }}
      </h1>

      <div #cashbackContainer></div>
      <!-- <kbk-upload-receipt campaign-id="100" width="100"></kbk-upload-receipt> -->

    </div>
  </div>
</div>
